'use client';

import type { ResourcesConfig } from 'aws-amplify';

import { Amplify } from 'aws-amplify';

const userPoolId = process.env.COGNITO_USER_POOL_ID?.trim();
const userPoolClientId = process.env.COGNITO_USER_POOL_CLIENT_ID?.trim();

if (!userPoolId || !userPoolClientId) {
    throw new Error('Missing Cognito configuration: USER_POOL_ID or USER_POOL_CLIENT_ID is not defined');
}

export const authConfig: ResourcesConfig['Auth'] = {
    Cognito: {
        userPoolId,
        userPoolClientId,
    }
};
Amplify.configure(
    {
        Auth: authConfig
    },
    { ssr: true }
);

export default function AmplifyClientSideConfiguration() {
    return null;
}
